import React from 'react';
import { Icon, Label, Popup } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const StatusButton = ({
  label,
  textColor,
  backgroundColor,
  creator,
  date,
  alternativePopupContent,
  showText,
  showOnlyPopup
}) => {
  const statusColor = backgroundColor;
  const statusTextColor = textColor;
  const popupContent =
    creator && date ? (
      <p>
        <Icon name="user" />
        {creator}
        <br />
        <Icon name="calendar alternate outline" />
        {date}
      </p>
    ) : (
      alternativePopupContent
    );

  const popup = popupContent && (
    <Popup
      basic
      position="top left"
      content={popupContent}
      trigger={
        <Icon
          name="info circle"
          style={{
            cursor: 'pointer',
            color: showOnlyPopup ? statusColor : null,
            backgroundColor: showOnlyPopup ? statusTextColor : null,
            borderRadius: '10px'
          }}
        />
      }
    />
  );

  return showOnlyPopup ? (
    <>{popup}</>
  ) : (
    <Label
      id="statusLabel"
      style={{
        background: statusColor,
        color: statusTextColor
      }}
      size="medium"
    >
      <>{popup}</>
      {showText && label}
    </Label>
  );
};

StatusButton.propTypes = {
  label: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  creator: PropTypes.string,
  date: PropTypes.string,
  alternativePopupContent: PropTypes.object,
  showText: PropTypes.bool,
  showOnlyPopup: PropTypes.bool
};

StatusButton.defaultProps = {
  textColor: 'white',
  showText: true,
  showOnlyPopup: false
};

export default StatusButton;
